import {LobbyHeaderLineCasino888WsopBox} from "./lobby-header-line.casino888Wsop.box";

export const LobbyHeaderLineWsopBox = LobbyHeaderLineCasino888WsopBox;
